import React from 'react';
import LegalPage from '../components/LegalPage';
import { COMPANY } from '../config/company';

const RefundPolicy = () => (
  <LegalPage title="Refund Policy" intro="Lokyis Ltd sells digital products and digital access. This policy explains how to request help with a purchase or access problem.">
    <h2>Digital content</h2>
    <p>Product-specific pricing and the content included are shown before payment. Where Lokyis Ltd sells paid digital access, it is provided electronically through the relevant customer account; no physical product is shipped. Dreamly Land is currently in development and is not presented on this website as available for purchase.</p>

    <h2>Access or technical problems</h2>
    <p>If paid content does not appear in your account, you are charged incorrectly, or a technical problem prevents access, email <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a>. Please include the email address associated with the account, the date of purchase and a brief description of the problem. Do not send complete payment card details.</p>

    <h2>Requesting a refund</h2>
    <p>To request a refund, contact us at <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a> with enough information for us to identify the purchase. We will consider the request based on the circumstances, whether the digital content has been accessed, this policy and applicable consumer law.</p>
    <p>Nothing in this policy limits rights or remedies that cannot be excluded under applicable consumer law. Eligibility and the method used to return funds can depend on how and where the purchase was made.</p>

    <h2>Approved refunds</h2>
    <p>If a refund is approved, it will normally be returned to the original payment method. Processing time may depend on the payment provider and the customer’s bank.</p>

    <h2>Contact</h2>
    <p>This policy is provided by {COMPANY.legalName}. Contact <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a> with purchase, access or refund questions.</p>
  </LegalPage>
);

export default RefundPolicy;
